var _defs, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 250",
    style: {
      enableBackground: "new 0 0 319 250"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F9FF;}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{fill:#E58676;}\r\n\t.st3{fill:#FFE3D1;}\r\n\t.st4{fill:#FFA694;}\r\n\t.st5{fill:#4F332E;}\r\n\t.st6{fill:#EFBCA0;}\r\n\t.st7{fill:#1A8476;}\r\n\t.st8{fill:#8C8F99;}\r\n\t.st9{fill:#B4B2C2;}\r\n\t.st10{fill:#AEB2BE;}\r\n\t.st11{fill:#A7D5F7;}\r\n\t.st12{fill:#076D5C;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:#ED5702;}\r\n\t.st15{fill:#FABF48;}\r\n\t.st16{fill:#E09819;}\r\n\t.st17{fill:#22231E;}\r\n\t.st18{fill:#FBE6D5;}\r\n\t.st19{fill:#E07D6C;}\r\n\t.st20{fill:#C2573C;}\r\n\t.st21{fill:#502B25;}\r\n\t.st22{fill:#512C26;}\r\n\t.st23{fill:#6D9AFF;}\r\n\t.st24{fill:#3B7DF2;}\r\n\t.st25{fill:#C44405;}\r\n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.362913131713867, 2.391937971115116)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.5,
    cy: 125,
    r: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,32.3c4.3,0.1,8.6,0.8,12.7,2c3,0.9,4.4,3.3,6.8,5.2c1.8,1.4,3.4,2.5,3.6,5c0.2,3-1.9,5.3-3.9,7.2 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-3-6.1-9-5.1-13.9-8.3 c-4-2.6-2.3-5.6-3.5-9.5c0-0.1,0-0.1,0-0.2C81.1,33.1,80.2,32.3,81,32.3z",
    style: {
      clipPath: "none",
      fill: "rgb(71, 27, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119,86.8c2.5,1.6,9,18,10.1,20.9c0.5,1.3,2.2,7.5,2.5,7.7c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4 c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.2,0.4c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.4c-1.4,1.2-3.2,2-5.1,2.1 c-3.7,0.3-7.3-1.9-11-1.3c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2-0.1-0.3-0.2s-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.4c0,0,1,0.9,1,0.9 c-0.7-4.8-1.7-9.6-3-14.3c-0.7-2.8-3.8-14.5-3.9-15.3C108.3,86.4,116.5,85.1,119,86.8z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.5,72.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.7-0.2c0.5,0,0.9,0,1.4,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0s0,0,0,0c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,0.9-0.7,1.5-0.7c0.5-0.1,0.9,0,1.4,0.2s0.8,0.5,1,0.9 c0.1,0.2,0.2,0.4,0.4,0.6c2.4-0.3,4.8-0.8,7.2,0c2.1,0.7,3.6,2.9,5.8,6.4c3.4,5.6,3.8,6.8,6.8,13c-2,0.6-4.1,1.1-6.2,1.5 c-1.7,0.1-3.4-0.1-5.1-0.5c-0.1,0-0.3-0.1-0.4-0.2c-0.2,0-0.7,0.4-0.8,0.2c-2.9-3-6.4-5.5-9.3-8.4c-2.4-2.4-2.7-6.1-4.8-8.8v0 l0-0.1C94.7,73.9,94.2,73.4,94.5,72.8z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.4,156.7c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3c2.7-1.7,5.5-3.2,8.3-4.5c1.9-0.8,4-1.7,6-1 c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.5c2.6,5.6,5.4,11.1,8.6,16.4c4.3,1.3,3.5,5.9,3,9.5c-0.5,3.4-1.3,6.7-2.5,9.9 c-0.5,1.3-0.8,2.7-2.2,3.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.2c-0.3-0.3-0.5-0.6-0.7-0.9c-0.2-0.4-0.3-0.8-0.3-1.1 c-0.1-0.1-0.2-0.2-0.3-0.3c-3-5.6-5.9-11-10-15.9c-3.6-4.6-7-9.4-10.1-14.4c-0.1-0.1-0.1-0.2-0.1-0.3 C38.3,156.9,38.3,156.8,38.4,156.7z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.4,128.2c0.8-2.3-1-4.7-0.6-7.1c0.4-2.3,1.8-4,1.7-6.4c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2 c-0.5-1.8-1.1-5-0.9-6.7c0.3-3.1,16.1,1.3,17.5,2.8c1.6,1.7,1.7,4.1,2.7,6.1c5.5,10.9,9.2,32.8-6.6,36.3 C118.4,154.4,108.5,139.3,112.4,128.2z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.5,85.7c-0.5,0-1.1,0-1.6-0.1c-0.7,0-1.3-0.1-1.9-0.2l-0.6-0.1c-1.6-0.3-3.1-0.6-4.7-0.9 c-3.3-0.7-6.6-1.2-9.9-2.1c-0.4-0.1-0.8-0.2-1.2-0.4c2.1-6,2-13.3,1.8-19.8c0-0.8-0.2-1.5-0.5-2.2c-2.1-4.3-3.9-8.8-3-13.7 c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0 c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.2c3.3,4.5,7.3,8.4,11.9,11.5c3,2,6.3,3.4,8.1,6.6c0.1,0,0.2,0,0.2,0.1 c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.2c-0.5,4.1-1,8.2-1.5,12.3C89.5,80,89.7,82.9,90.5,85.7z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.4,69.2c4,2.1,6.9,2.5,6.4,2.3c-0.6,1.2-0.6,4.9-1,7.2C85.5,73.8,85.1,71.5,84.4,69.2z",
    style: {
      fill: "rgb(231, 122, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.6,126c4.7-13.6,16.1-27.6,26.8-37.4c0.6-0.5,0.9,0.2,0.9,0.8c0.1,0.1,0.1,0.1,0.2,0.2 c2.7,3.8,2,9.3,2.3,13.7c0.4,5.9,2.1,12.3,1.6,18.1c-0.4,5.1-3.4,7.3-6.2,11.3c-1.1,1.7-2,3.1-2.6,4c-0.2,0.3-0.2,0.6-0.3,0.9 c0,0.3,0,0.6,0.1,0.9c0.9,3,3.2,9.8,3.9,11.8c0.4,1.1,1.3,2.8,0.9,3.9c-0.9,2.5-5,4.1-7.2,4.7c-3.3,1-6.9,1.6-10.3,0.9 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.3C32.9,153,23.8,137.3,27.6,126z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59.3,156.7c-0.2,3.6-0.1,7.1-0.4,10.6c-0.1,1.1-0.2,2.1-0.4,3.2c-0.7,4-2.6,7.9-3.8,11.7 c-0.1,0.2-0.1,0.4-0.2,0.5c19.5,36.1,53.8,52.4,70,56.7c-0.7-7.2-2.3-31.7-4.1-40.3c-2.3-10.6-5.8-21-9.6-31.1 c-0.1-0.4-0.2-0.8-0.3-1.2c-0.3-2.9-0.8-5.7-1.5-8.5c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.1-0.3,0-0.4c0-0.1-0.1-0.3-0.2-0.4 c-0.1-0.1-0.2-0.2-0.4-0.3l-0.2-0.1c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0.1 c-7-2.1-13.6-1.7-20.9-0.6c-8.8,1.3-17.5-1.1-26.4-0.1c-0.2,0.1-0.5,0.2-0.7,0.3C59.6,156.3,59.4,156.5,59.3,156.7z",
    style: {
      fill: "rgb(195, 73, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.6,46.1c0.6-5.1,4.5-11.6,9.7-12.2c8-0.9,16.4,4.5,20.2,9.4c3,3.8,2.9,12.1,2.9,12.1s0.5,1.7,0.7,2.3 c0.5,1.3,1.5,2.2,1.1,2.7c-0.5,0.8-1.1,0.8-1.9,0.8c-0.1,0.4-0.1,0.1-0.1,0.8c0,0.4,0,0.8,0,1.2c0,0.7,0,1.3,0,2 c0,2.5-0.2,5.2-1.5,6.4c-1.3,1.1-3.9,0.7-5.5,0.5c-5-0.4-11.2-1.3-14.1-6c-0.6-0.9-1.1-3.3-1.9-3.9 C72.8,58.2,67.7,53.1,68.6,46.1z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.8,96.6c0.9-6.1,6.5-9.9,11.2-12.9c7.2-4.7,13.1-8.8,22.4-5.6c7.8,2.7,15.1,8.9,20.7,14.7 c4.9,5,5.9,10.6,5.7,17.4c-0.1,5.2,1.1,20.3,1.5,23c0.8,5.8,2,21.7-1.4,25.3c-2.7,2.9-6,2.4-9.4,1.9c-5.5-0.9-11.3-1.9-16.9-1.8 c-3.8,0.1-7.6,0.6-11.3,1.2c-3.2,0.5-7.2,2-10.2,0.4c-3.3-1.8-4.2-6.2-4.7-9.5c-0.9-5.8-1.2-11.7-1.7-17.6 c-0.5-5.5-1.3-11-2.6-16.5c-0.2-0.7-0.4-1.4-0.5-2.1C51,108.7,48.8,102.8,49.8,96.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.5,83.8c8,3.9,15.1,12.7,19.6,20.5c4.5,7.9,8.2,15,12.4,23.3c1.8,3.4,3.7,6.9,5.1,10.5 c1.2,2.9,5,8.7,2.7,11c-3.3,3.2-10.4,7.4-21-1.5c-15.5-13-19.7-26.2-24.1-36.5c-1.9-4.5-4.1-9.2-3.9-14.2 C84.3,91.4,92.4,83.2,93.5,83.8z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,91.6c0.3-3.7,2.2-7,3.5-10.4c1.5-3.9,2.2-8,2.9-12c0.6-4.1,1.7-8.1,3.3-12c2.8-6.7,4-15.6,9.2-21.1 c4.5-4.8,16.3-5.2,22.1-1.1c2.1-0.5,4.1,0.4,5.7,1.9c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.3,0.4,0.7,0.6,1.1 c0.5,0.7,0.9,1.5,1.2,2.4c0,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c0,3.5-1.9,6.6-3.4,9.6c-1.5,2.9-4.4,4.7-7.3,6c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.5,0,1.1,0,1.7 c0.2,2.9,1.2,5.7,1.4,8.6c0.1,2-0.2,4.1-0.7,6.1c-0.7,3.3-0.8,6.7-0.3,10c0.4,3.3,0.8,7.1-1.1,10.1c-2.7,4.2-7.8,3.2-12,3.1 c-2.8-0.1-5.7-0.3-8.5-0.4c-2.9-0.1-5.7,0.4-8.6,0.5C52.5,99,49.3,95.9,49.7,91.6z",
    style: {
      clipPath: "none",
      fill: "rgb(71, 27, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7,50.7c-0.1-0.4,0.2-1,0.2-1s0.7-0.7,1.1-0.9c0.8-0.4,3.6,0.4,4.3,1.3c0.2,0.2,0.2,0.4,0.2,0.7 c0,0.3-0.2,0.4-0.4,0.6c-0.3,0.3-1.6-0.6-2.7-0.6c-0.9,0-1.7,0.7-2.2,0.4C95,51,94.9,51,94.7,50.7z",
    style: {
      clipPath: "none",
      fill: "rgb(71, 27, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.1,54.5c0.3-0.3,0.7-0.6,1.2-0.7c3.6-0.7,5,5.2,3.9,7.6c-2,4.3-5.4-2.2-5.8-4.2c-0.1-0.5-0.1-1,0-1.5 C83.6,55.3,83.8,54.9,84.1,54.5z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.3,53.9c0.1-0.5,0.3-1,0.7-1.1c0.8-0.2,1.4,0.7,1.5,1.2c0,0.4,0,0.9-0.2,1.3c-0.1,0.1-0.1,0.3-0.3,0.4 c-0.1,0.1-0.3,0.2-0.4,0.3C97.7,56.3,97.2,55,97.3,53.9z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.6,117.3c1.4,2.9,3,5.7,4.8,8.4c1.6,2.6,3.2,5.2,4.9,7.7c3.4,5.2,7.5,10,12,14.3c0.2,0.2-0.1,0.6-0.4,0.4 c-4.5-4.1-8.4-8.8-11.8-13.9c-1.7-2.5-3.3-5.1-4.9-7.7c-1.9-2.9-3.6-5.8-5.1-8.9C89,117.3,89.4,117,89.6,117.3L89.6,117.3z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M 89 116.8 C 88.7 117 88.5 117.3 88.7 117.8 C 90.2 120.89999999999999 91.9 123.89999999999999 93.8 126.8 C 93.8 126.89999999999999 93.89999999999999 127 93.89999999999999 127 C 95.49999999999999 129.5 96.99999999999999 132 98.69999999999999 134.5 C 102.1 139.6 106.1 144.3 110.6 148.5 C 111 148.8 111.39999999999999 148.7 111.6 148.5 C 111.69999999999999 148.4 111.8 148.2 111.8 148 C 111.8 147.8 111.7 147.6 111.6 147.4 C 107.1 143.20000000000002 103 138.4 99.6 133.20000000000002 C 97.89999999999999 130.70000000000002 96.3 128.10000000000002 94.69999999999999 125.50000000000001 C 92.89999999999999 122.80000000000001 91.39999999999999 120.00000000000001 89.99999999999999 117.10000000000001 C 89.89999999999999 116.9 89.69999999999999 116.80000000000001 89.49999999999999 116.7 C 89.3 116.7 89.1 116.7 89 116.8 Z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M 89.1 117.6 C 89.1 117.6 89.1 117.6 89.1 117.6 C 89.1 117.5 89.1 117.6 89.1 117.6 Z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M 89.1 117.6 C 89.1 117.6 89.1 117.6 89.1 117.6 C 89.1 117.6 89.1 117.6 89.1 117.6 Z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.9,107.6c3.9,7,8.6,13.7,10.6,21.5c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.1c-2-7.8-6.6-14.5-10.5-21.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0 C114.8,107.5,114.8,107.5,114.9,107.6z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.8,107c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c-0.1,0.2-0.1,0.4,0,0.5l0,0l0,0 c0.8,1.5,1.7,3,2.6,4.4c3.2,5.4,6.4,10.8,7.9,16.9l0,0l0,0c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.1,0.5,0.1 c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.2,0.1-0.4,0.1-0.5l0,0l0,0c-1.6-6.3-4.9-11.8-8.1-17.3c-0.9-1.5-1.7-2.9-2.5-4.4l0,0l0,0 C115.2,107.1,115,107,114.8,107z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.1,113.2c0.6,5.4,1.7,10.7,3.3,15.8c0.1,0.3-0.4,0.4-0.5,0.1c-1.6-5.2-2.8-10.5-3.3-15.9 C51.6,112.9,52.1,112.9,52.1,113.2L52.1,113.2z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.4,112.7c-0.2,0.2-0.2,0.4-0.2,0.6l0,0c0.6,5.4,1.7,10.8,3.3,16l0,0l0,0c0.2,0.5,0.6,0.6,0.9,0.5 c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0.1-0.4,0.1-0.6c-1.6-5-2.7-10.2-3.3-15.5l0,0l0-0.2c0-0.5-0.5-0.7-0.8-0.7 C51.7,112.5,51.5,112.5,51.4,112.7z",
    style: {
      fill: "rgb(85, 137, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.3,72.4c1.1,0.8,1.8,2,2.1,3.3c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.1c-0.3-1.2-1-2.3-2-3.1C96.7,72.6,97.1,72.2,97.3,72.4L97.3,72.4z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.3,71.7c0.8,1,1.5,2.1,2,3.2c0.1,0.3-0.3,0.5-0.4,0.2c-0.5-1.1-1.1-2.2-1.9-3.1 C101.8,71.8,102.1,71.5,102.3,71.7L102.3,71.7z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.8,55.5c0.7,0.3,1.3,0.7,1.8,1.2c0.5,0.6,0.8,1.2,1,1.9c0.1,0.3-0.4,0.4-0.5,0.1 c-0.1-0.6-0.4-1.2-0.8-1.7c-0.4-0.5-0.9-0.9-1.5-1.1C85.4,55.9,85.5,55.4,85.8,55.5z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.5,170.8c-15.2,3.4-31,3.5-46.2,0.2c-0.3-0.1-0.2-0.5,0.1-0.5c15.2,3.2,30.8,3.1,46-0.2 C108.7,170.3,108.8,170.7,108.5,170.8z",
    style: {
      fill: "rgb(156, 60, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M 109.2 170.4 C 109.10000000000001 170.1 108.8 169.8 108.3 169.9 C 93.2 173.20000000000002 77.6 173.3 62.599999999999994 170.1 C 62.099999999999994 170 61.8 170.29999999999998 61.699999999999996 170.6 C 61.699999999999996 170.79999999999998 61.699999999999996 171 61.699999999999996 171.1 C 61.8 171.29999999999998 61.99999999999999 171.4 62.199999999999996 171.5 C 77.5 174.7 93.39999999999999 174.6 108.6 171.3 L 108.5 170.8 L 108.6 171.3 C 108.8 171.20000000000002 109 171.10000000000002 109.1 170.9 C 109.2 170.7 109.2 170.5 109.2 170.4 Z",
    style: {
      fill: "rgb(156, 60, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M 62.3 171.1 C 62.3 171.1 62.3 171.1 62.3 171.1 Z",
    style: {
      fill: "rgb(156, 60, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M88.4,40.2c-1.7,4.1-3.4,8.4-3.2,12.9c0,0.4-0.7,0.4-0.7,0c-0.2-4.7,1.5-8.9,3.2-13.1 C87.9,39.6,88.6,39.8,88.4,40.2L88.4,40.2z",
    style: {
      fill: "rgb(46, 12, 18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.6,38.1c0.3,0.5,0.6,1.1,0.7,1.8c0.1,0.6,0.1,1.3-0.1,1.9c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0.1-0.3,0 c-0.1,0-0.2-0.1-0.2-0.2s-0.1-0.2,0-0.3c0.1-0.5,0.2-1.1,0.1-1.6c-0.1-0.5-0.3-1-0.6-1.5C96.8,38.1,97.4,37.7,97.6,38.1 L97.6,38.1z",
    style: {
      fill: "rgb(46, 12, 18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.1,63.9c0.4,0,1.1-0.2,1.1-0.2c0,0.7,0,0.8,0,1.5c-0.4,0-0.8,0.1-1.3,0c-0.8-0.3-1.4-1.2-1.4-1.6 C99.1,63.9,99.5,63.9,100.1,63.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.2,33.7c0,0-1.4,5-1.6,10.2c-0.1,5.2-1.3,6.2-2.1,10.3c-2.2,11.3-5.3,25.2-4.8,29 c0.5,3.8,3.2,5.3,5.9,5.2c2.4-0.1,4.8-1.4,8.5-0.3c5,1.4,8.6-2.2,10-2.6c1.4-0.4,3.1-31-0.6-37.6S179.2,33.7,179.2,33.7z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.3,135.9l-22.8-9.1c0,0,16.3-37.6,22-42.5c5.7-4.9,15.2-9.5,25-11.8c9.8-2.3,22.4-5.1,39.5-8.1 c17.1-3,38.4,3,38.4,3v37l-13.1,1.9L239.1,170h-57.7l-15.3-43.2L160.3,135.9z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M188,72.3c3.4,3.8,8.1,6.2,13.2,6.5c1.4,0.1,2.8,0,4.2-0.2c0.4-0.1,0.2-0.7-0.2-0.6 c-4.9,0.7-9.8-0.5-13.8-3.4c-1.1-0.8-2.1-1.7-3-2.8C188.2,71.5,187.7,71.9,188,72.3L188,72.3z",
    style: {
      fill: "rgb(250, 232, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M209.7,49.6l1.5,17.2c0,0-4.8,6.1-10.9,6.7c-5.5,0.5-7-3-7-3l-1.2-9.5L209.7,49.6z",
    style: {
      fill: "rgb(255, 168, 138)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M198.6,60.2c-4,2.1-6.9,2.5-6.4,2.3c0.6,1.2,0.4,2.8,0.8,5.2C197.3,62.7,197.8,62.4,198.6,60.2z",
    style: {
      fill: "rgb(247, 136, 98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.9,41c0,0-4.7-7.7,1-12.9c4.3-3.9,12-3.5,12-3.5L180.9,41z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M210.2,31.3c-3.7-8.1-13-8.7-20.2-5.4c-4.8,2.2-7.3,5.7-8.5,10.8c-0.8,3.7-0.5,7.7-0.5,10.3 c0,1.8,0.4,5.3,1.2,9.4c1,5.1,4.6,7.7,12,6c12.3-3,20-13.4,16.9-27.9C210.9,33.4,210.6,32.3,210.2,31.3z",
    style: {
      fill: "rgb(255, 168, 138)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.4,49.5c-0.5,0.7-1,1.4-0.6,2.3c0.2,0.4,0.5,0.7,0.8,0.9c0.4,0.2,0.8,0.3,1.2,0.3c0.1,0,0.1,0,0.2-0.1 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2s-0.1-0.1-0.2-0.1c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.1-0.5-0.3-0.6-0.6 c-0.3-0.6,0.1-1.3,0.5-1.8C186,49.6,185.6,49.2,185.4,49.5z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M186.9,51.9c0.2-0.1,0.5-0.1,0.7,0c0.2,0,0.5,0.1,0.7,0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-0.3-1.2-0.4-1.8-0.3c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0,0.2 c0,0.1,0.1,0.1,0.1,0.2C186.7,51.9,186.8,51.9,186.9,51.9z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M183.1,45.5c1.2,0,1.2,1.2,1,1.8c-0.1,0.3-0.4,0.7-1,0.8c-0.8,0-0.9-0.8-0.9-1.2 C182.2,46.4,182.2,45.6,183.1,45.5z",
    style: {
      fill: "rgb(66, 43, 43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.3,42.9c0,0.6-1.5-0.3-3.7,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c-0.7-0.5-1-0.9-0.1-1.7c0.5-0.1,1-0.2,1.4-0.2 C185.2,41.4,185.3,42.1,185.3,42.9z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.2,31c-3.6-8.2-17.9-8.7-25.1-5.4c-4.8,2.2-4.2,3-5.3,8.1c-0.1,0.5,0.3,2.1,0.2,2.7 c0.6-1.9,0.4-1.4,1.4-3.2c0,0,5.4,7.5,18.4,10.4c2,0.5,2.3,1.1,2.2,2.9c-0.3,4.5-0.8,8,3.3,10.9c1.4,0.6,3,0.8,4.6,0.6l-1-8.2 C212.5,44.8,214.4,38.3,211.2,31z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M191.7,31.8c3,3.4,5.9,6.8,7.1,11.2c0.1,0.4,0.8,0.2,0.6-0.2c-1.3-4.5-4.2-8-7.2-11.4 C192,31.1,191.4,31.5,191.7,31.8L191.7,31.8z",
    style: {
      fill: "rgb(129, 61, 44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.1,33.3c0,0,6.8,22.2,8.4,26.1s0.7,3.6,1.8,4.7c1.1,1.1,4.7,11.8,3.5,15.3c-1.2,3.6-7.5,2.5-9.3,2 c-1.9-0.5-11.4,7.7-13.9,8.1c-2.4,0.3-6.8,0.6-9.2-2.5c-2.1-2.8,5.7-30.1,6.8-32.1c1.5-2.7,0.8-6.6,0.8-6.6l7.7-2.4L212.1,33.3z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M194.5,47.9c0.1,1,0.4,1.9,1,2.6c0.6,0.8,1.4,1.3,2.3,1.7c0.9,0.3,1.9,0.4,2.8,0.1c0.9-0.2,1.8-0.7,2.4-1.5 c0.6-0.7,1-1.6,1.2-2.5c0.1-0.9,0-1.9-0.4-2.8c-0.4-0.9-1.1-1.6-1.9-2.1c-0.8-0.5-1.8-0.7-2.7-0.7c-1.3,0.1-2.5,0.7-3.3,1.6 S194.4,46.7,194.5,47.9z",
    style: {
      fill: "rgb(255, 168, 138)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.5,44.6c-1.9,0.1-2.3,2.3-2.8,3.7c-0.1,0.3,0.3,0.4,0.4,0.1c0.4-1.2,0.7-3.3,2.4-3.4 C201.8,45,201.8,44.6,201.5,44.6z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.7,47.3c-0.1-0.5-1.2-0.8-1.8-0.7c-0.3,0.1-0.2,0.4,0.1,0.3c0.3-0.1,1.2,0.1,1.2,0.5 c0,0.2-0.3,0.5-0.4,0.6l-0.8,1.2c-0.1,0.2,0.3,0.4,0.4,0.2c0.3-0.5,0.6-0.9,0.9-1.4C201.5,47.8,201.8,47.5,201.7,47.3z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M190.2,45.6c1.2-0.1,1.2,1.2,1,1.8c-0.1,0.3-0.4,0.7-0.9,0.8c-0.8,0-1-0.8-1-1.2 C189.3,46.5,189.4,45.6,190.2,45.6z",
    style: {
      fill: "rgb(66, 43, 43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M236,171.8c0,0,4.2,1.3,13.7,31.4c0.1,0.4,0.1,0.3,0.2,0.7c-23.3,27.8-54.8,38.7-83.4,40.8 c3.5-33.3,6.8-63.8,6.8-63.8L236,171.8z",
    style: {
      fill: "rgb(23, 9, 53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M187.5,42.5c0.5,1.4,2.2,0.4,3.6,0.5c1.5,0.1,3.2,0.9,3-0.3c-0.2-0.7-3.3-1.3-3.3-1.3S187,41.2,187.5,42.5z",
    style: {
      fill: "rgb(156, 80, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.4,56.1c0,0,2.9,0.6,5.3-1.6c0,0.7-0.2,1.3-0.6,1.8c-0.4,0.5-0.9,0.9-1.5,1.1 C186.8,58,185.4,56.1,185.4,56.1z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M221.4,32.9l8.9,0.6l8.9,0.6l17.7,1.3l17.7,1.3l8.9,0.6l8.9,0.6c-0.3,0.3-0.5,0.6-0.8,0.9 c-0.8,1-1.6,2-2.4,3c-0.8,1-1.6,2-2.3,3c-0.7,1-1.4,2-2.2,2.9c-0.7,1-1.4,1.9-2,2.9c-0.7,1-1.4,2-2,3.1c-0.6,1-1.3,2-1.9,3 c-0.6,1-1.2,2-1.7,3c-0.6,1-1.1,2-1.6,3c-0.5,1-1,2-1.5,3c-0.5,1-0.9,1.9-1.4,2.9c-0.4,1-0.9,1.9-1.3,2.9c-0.4,1-0.8,2-1.2,3 c-0.4,1-0.8,2-1.1,3c-0.4,1-0.7,2-1.1,3c-0.3,1-0.7,2-1,3c-0.3,1-0.6,2-0.9,3c-0.3,0.9-0.5,1.9-0.8,2.9c-0.3,1-0.5,2-0.8,3.1 c-0.2,1-0.5,2-0.7,3c-0.2,1-0.4,2-0.7,2.9c-0.2,1-0.4,2-0.6,3.1c-0.2,1-0.4,2-0.6,3.1c-0.2,1-0.3,1.9-0.5,2.9 c-0.2,1-0.3,2.1-0.5,3.2c-0.1,0.9-0.3,1.9-0.4,2.9c-0.1,1-0.3,2-0.4,3.1c-0.1,1-0.3,2-0.4,3c-0.1,1-0.2,2-0.3,3 c-0.1,1-0.2,2-0.3,3c-0.1,1-0.2,2-0.3,3c-0.1,1-0.2,1.9-0.2,2.9c-0.1,1-0.1,2-0.2,3c0-0.2,0,0.1,0,0c-0.1,1-0.1,2-0.2,3 c-0.1,1-0.2,2-0.3,3c-0.1,1-0.2,2-0.4,3c-0.1,1-0.3,2-0.4,3c-0.1,1-0.3,2-0.5,2.9c-0.2,1-0.4,2-0.6,3.1c-0.2,1-0.4,2-0.6,3 c-0.2,1-0.4,2-0.7,3c-0.2,1-0.5,2-0.7,3c-0.3,1-0.5,2-0.8,3c-0.3,1-0.6,2-0.9,3c-0.3,1-0.6,2-0.9,2.9c-0.3,1-0.7,2-1,3.1 c-0.4,1-0.7,2-1.1,3c-0.4,1-0.8,2-1.2,3c-0.4,1-0.8,2-1.3,3c-0.4,1-0.9,2-1.3,3c-10.4,22.7-25.3,39.4-38.2,49.2 c-49.8,21.5-94.4,0-94.4,0c16.4-13.5,34.4-27.9,49.1-50.7c0.7-1.2,1.5-2.3,2.2-3.4c0.6-1,1.3-2.1,1.9-3.1c0.6-1,1.1-2,1.7-2.9 c0.6-1,1.1-2.1,1.7-3.1c0.5-1,1.1-2,1.6-3c0.5-1,1-2,1.5-2.9c0.5-1,1-2.1,1.4-3.1c0.5-1,0.9-2,1.3-3c0.4-1,0.9-2,1.3-3 c0.4-1,0.8-2,1.2-3c0.4-1,0.7-2,1.1-3c0.3-1,0.7-2,1-3c0.3-1,0.6-2,0.9-2.9c0.3-1,0.6-2,0.9-3.1c0.3-1,0.5-2,0.8-2.9 c0.3-1,0.5-2.1,0.8-3.1c0.2-1,0.5-2,0.7-3.1c0.2-1,0.4-1.9,0.6-2.9c0.2-1,0.4-2,0.6-3c0.2-1,0.4-2,0.5-3c0.2-1,0.3-2,0.5-2.9 c0.2-1,0.3-2,0.4-3c0.1-1,0.3-2,0.4-3.1c0.1-1,0.3-2,0.4-3.1c0.1-1,0.3-2,0.4-3c0.1-1,0.3-2,0.4-3c0.1-1,0.3-2,0.4-3.1 c0.1-1,0.3-2,0.4-3c0.1-1,0.3-2,0.4-3c0.1-1,0.3-2,0.4-3c0.2-1,0.3-2,0.5-3c0-0.3,0.1-0.6,0.2-0.9c0.1-0.7,0.2-1.4,0.4-2.1 c0.2-1,0.4-2,0.6-2.9c0.2-1,0.5-2,0.8-3c0.3-1,0.6-2,0.9-3c0.3-1,0.6-2,1-2.9c0.4-1,0.7-2,1.1-3c0.4-1,0.8-2,1.2-3 c0.4-1,0.9-2,1.4-3c0.5-1,1-2,1.5-3c0.5-1,1-2,1.6-2.9c0.6-1,1.1-2,1.7-3c0.6-1,1.2-2,1.8-3c0.6-1,1.3-2,1.9-2.9 c0.7-1,1.3-2,2-2.9c0.8-1.1,1.5-2.1,2.3-3.1c0.8-1.1,1.6-2.1,2.3-3c0.8-1.1,1.7-2,2.4-2.9c1-1.2,1.9-2.2,2.8-3.2 c1.2-1.3,2.2-2.3,2.9-3C221.1,33.3,221.4,32.9,221.4,32.9z",
    style: {
      fill: "rgb(250, 231, 220)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M223.3,115.9c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.3,0.8,1.2,1.5l0,0.1c-0.1,0.7-0.7,1.2-1.4,1.1 C223.7,117.4,223.2,116.7,223.3,115.9L223.3,115.9z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M221,133.8c0.1-0.7,0.7-1.2,1.4-1.1c0.8,0.1,1.3,0.7,1.2,1.5l0,0.1c-0.1,0.7-0.7,1.2-1.4,1.1 C221.4,135.4,220.8,134.7,221,133.8L221,133.8z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M207.2,178.5c0.2-0.5,0.8-0.8,1.3-0.8l0.1,0c1,0.1,1.6,1.1,1.2,2c-0.2,0.5-0.8,0.8-1.3,0.8l-0.1,0 C207.4,180.4,206.8,179.4,207.2,178.5z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M211.3,169.5c0.2-0.5,0.8-0.9,1.4-0.8c0.9,0.1,1.5,1,1.2,1.9l0,0.1c-0.2,0.5-0.8,0.9-1.4,0.8 C211.5,171.4,210.9,170.5,211.3,169.5L211.3,169.5z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M214.7,160.6c0.2-0.6,0.8-1,1.4-0.9c0.9,0.1,1.5,1,1.2,1.8l0,0.1c-0.2,0.6-0.8,0.9-1.4,0.9 C215,162.4,214.4,161.5,214.7,160.6L214.7,160.6z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M217.4,151.7c0.2-0.6,0.7-1,1.4-1c0.9,0.1,1.5,0.9,1.2,1.7l0,0c-0.2,0.6-0.7,1-1.4,1 C217.7,153.4,217.1,152.6,217.4,151.7L217.4,151.7z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M222.1,124.9c0.1-0.7,0.7-1.2,1.4-1.1c0.8,0.1,1.3,0.7,1.2,1.5l0,0c-0.1,0.7-0.7,1.2-1.4,1.1 C222.6,126.4,222,125.7,222.1,124.9L222.1,124.9z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.4,142.9c0.1-0.7,0.7-1.2,1.4-1.1c0.8,0.1,1.3,0.7,1.2,1.5l0,0c-0.1,0.7-0.7,1.2-1.4,1.1 C219.8,144.4,219.3,143.7,219.4,142.9L219.4,142.9z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M232.4,116.5c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.3,0.8,1.2,1.5l0,0.1c-0.1,0.7-0.7,1.2-1.4,1.1 C232.9,118,232.3,117.4,232.4,116.5L232.4,116.5z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M230.2,134.5c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.4,0.8,1.2,1.5l0,0c-0.1,0.7-0.7,1.2-1.4,1.1 C230.7,136,230.1,135.3,230.2,134.5L230.2,134.5z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M217.3,179.1c0.2-0.5,0.8-0.8,1.3-0.8l0.1,0c1,0.1,1.6,1.1,1.1,2c-0.3,0.5-0.8,0.8-1.3,0.7l-0.1,0 C217.5,181,216.9,180,217.3,179.1z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M221.2,170.2c0.2-0.6,0.8-0.9,1.4-0.9c1,0.1,1.6,1.1,1.2,2c-0.2,0.5-0.8,0.9-1.4,0.9 C221.4,172.1,220.8,171.1,221.2,170.2z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M224.4,161.3c0.2-0.6,0.8-1,1.4-1c0.9,0.1,1.5,1,1.2,1.9c-0.2,0.6-0.8,1-1.4,0.9 C224.7,163.1,224.1,162.2,224.4,161.3z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M226.9,152.3c0.2-0.6,0.7-1,1.3-1c0.8,0.1,1.4,0.9,1.2,1.7l0,0.1c-0.2,0.6-0.7,1-1.3,0.9 c-0.8-0.1-1.4-0.8-1.2-1.6L226.9,152.3z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M231.3,125.6c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.3,0.7,1.2,1.5l0,0.1c-0.1,0.7-0.7,1.2-1.4,1.1 C231.8,127.1,231.2,126.4,231.3,125.6L231.3,125.6z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M228.9,143.4c0.1-0.7,0.7-1.1,1.4-1.1c0.8,0.1,1.3,0.8,1.2,1.6l0,0.1c-0.1,0.6-0.7,1.1-1.4,1 c-0.8-0.1-1.3-0.8-1.2-1.6L228.9,143.4z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.8,116.2c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.3,0.8,1.2,1.5l0,0.1c-0.1,0.7-0.7,1.2-1.4,1.1 C228.3,117.7,227.7,117.1,227.8,116.2L227.8,116.2z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M225.6,134.2c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.4,0.8,1.2,1.5l0,0c-0.1,0.7-0.7,1.2-1.4,1.1 C226.1,135.7,225.5,135,225.6,134.2L225.6,134.2z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M212.3,178.8c0.2-0.5,0.8-0.8,1.4-0.8c1,0.1,1.6,1.1,1.2,2c-0.3,0.5-0.8,0.8-1.3,0.8 C212.5,180.7,211.8,179.7,212.3,178.8z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M216.2,169.8c0.2-0.6,0.8-0.9,1.4-0.9c1,0.1,1.6,1.1,1.2,1.9l0,0.1c-0.2,0.5-0.8,0.9-1.4,0.8 C216.5,171.7,215.9,170.8,216.2,169.8L216.2,169.8z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M219.5,160.9c0.2-0.6,0.8-1,1.4-0.9c0.9,0.1,1.5,1,1.2,1.8l0,0.1c-0.2,0.6-0.8,0.9-1.4,0.9 C219.8,162.7,219.2,161.8,219.5,160.9L219.5,160.9z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M222.1,152c0.2-0.6,0.7-1,1.3-1c0.8,0.1,1.4,0.9,1.2,1.7l0,0.1c-0.2,0.6-0.7,1-1.3,0.9 C222.5,153.7,221.9,152.9,222.1,152L222.1,152z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M226.7,125.3c0.1-0.7,0.7-1.2,1.4-1.2c0.8,0.1,1.3,0.7,1.2,1.5l0,0c-0.1,0.7-0.7,1.2-1.4,1.1 C227.2,126.7,226.6,126,226.7,125.3L226.7,125.3z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M224.2,143.1c0.1-0.7,0.7-1.1,1.4-1.1c0.8,0.1,1.3,0.8,1.2,1.6l0,0.1c-0.1,0.6-0.7,1.1-1.4,1 C224.6,144.7,224,144,224.2,143.1L224.2,143.1z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.6,136.6c6.2,2.7,11.5,3.3,18.3,3.4c1,0,2.4,1.2,1.5,1.3c0,0.1-0.1,0.2-0.2,0.3c-1.7,1.6-3.6,3.3-4.6,5.5 c-0.9,1.8-2.7,2.2-3.9,3.9c-0.2,0.3-2.6,0.3-2.9,0.2c-6-1.2-12.2-1.2-18.2-1.9c-8.3-1-17.8-1.8-25.3-5.7c-1.8-0.9-3.3-2.2-4.3-4 c-1-1.8-1.3-3.8-1-5.8c0.3-2,1.4-3.8,2.9-5.1c2.9-2.2,6.6-3.2,10.2-2.7c7.2,0.9,14.1,5.1,20.7,7.8 C181,134.7,183.3,135.6,185.6,136.6z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.6,140.5c3,0.4,5.8,1.3,8.5,2.6c3.1,1.8,7.2,4.4,8.7,8c0.1,0.7-0.8,1.5-1.3,1.4c-0.8,0.1-2.5-1.7-4.2-2.6 c-1.5-0.7-4.4-2-4.4-2s-2.2,5.9-4.2,7.6c-2.5,2-6.5,0.4-9.1-0.3c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0-0.1,0-0.1,0 c-0.6-0.4-2.7,0-3.5,0c-1.3-0.1-2.6-0.3-3.9-0.7c-2.8-1-4.3-3.2-5.9-5.6c-0.3-0.4,2.1-8.4,3-8.4c4.4-0.2,8.9-0.2,13.3,0.1 C209.2,140.2,210.4,140.3,211.6,140.5z",
    style: {
      fill: "rgb(245, 158, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M218.6,147.6c-1-2.2-3.2-3.4-5.3-4.3c-0.4-0.2-0.1-0.7,0.3-0.6c2.2,1,4.5,2.3,5.5,4.6 C219.3,147.6,218.8,148,218.6,147.6L218.6,147.6z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M216.7,150.9c-0.8-2.3-3.3-3-5.4-3.4c-0.4-0.1-0.3-0.7,0.2-0.6c2.4,0.4,5,1.3,5.9,3.8c0,0.1,0,0.2,0,0.2 c0,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.2,0C216.8,151.1,216.8,151,216.7,150.9z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.8,153.9c-1.1-1.4-2.8-1.7-4.4-2c-0.4-0.1-0.3-0.7,0.1-0.6c1.8,0.3,3.7,0.7,4.8,2.3 C214.6,153.8,214,154.2,213.8,153.9z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.2,155.2c-1.8-0.7-3.8-0.8-5.7-0.4c-0.4,0.1-0.6-0.5-0.2-0.6c2.1-0.5,4.2-0.3,6.2,0.4 C211.9,154.7,211.6,155.3,211.2,155.2z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.6,115.7l35.2,20l-4,14.2c0,0-38.2-1.3-43.2-14.2C132.5,122.2,149.6,115.7,149.6,115.7z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M168.4,116.8c-0.4-0.2-0.8-0.1-1,0.3l-3.7,6.1l-3.2,0.5c-0.4,0.1-0.7,0.4-0.6,0.9c0.1,0.4,0.4,0.7,0.9,0.6 l3.3-0.5l16.1,8.2c0.4,0.2,0.8,0,1-0.3c0.2-0.4,0-0.8-0.3-1l-15.6-7.9l3.4-5.7C168.8,117.4,168.7,117,168.4,116.8z",
    style: {
      fill: "rgb(174, 66, 5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M255.4,31.9l-8.4-0.5c-1.9-0.1-1.7,2.9,0,3.1c2,0.1,4.2,0.3,4.2,0.3s-3.3,2.2-2.2,4c1.1,1.8,4.1-0.5,4.1-0.5 s0.1,2,2.3,1.6c2.2-0.4,6.1-4.4,6.1-4.4l2.1,0.2c0,0-0.6-3.5-4-3.2C259.7,32.4,258.8,30.3,255.4,31.9z",
    style: {
      fill: "rgb(255, 168, 138)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M251.1,35c1.3-1,2.8-1.9,4.2-2.8c0.2-0.1,0-0.4-0.2-0.3c-1.5,0.8-2.9,1.7-4.2,2.7 C250.8,34.8,250.9,35.1,251.1,35z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M253.4,38.2c0.3-0.6,0.8-1.2,1.3-1.7c0.5-0.5,1-1,1.6-1.4c1.1-0.9,2.3-1.8,3.5-2.6c0.2-0.1,0-0.4-0.2-0.3 c-1.2,0.8-2.4,1.7-3.5,2.6c-0.6,0.5-1.1,1-1.6,1.5c-0.6,0.5-1,1-1.3,1.7C253,38.3,253.3,38.4,253.4,38.2L253.4,38.2z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M203.3,189.1l-31.1-4.4c-7.3-1-11.4,2.1-11,8.1c0.4,5.8,5.2,10.3,12.3,11.3l31.1,4.4 c6.1,0.9,10.7-2.8,10.3-8.1C214.6,194.9,209.4,190,203.3,189.1z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.3,193.7c-2.4-0.3-2.2,2.9,0.2,3.3S181.7,194,179.3,193.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M188,194.9c-2.4-0.3-2.2,2.9,0.2,3.3C190.6,198.5,190.4,195.3,188,194.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196.7,196.2c-2.4-0.3-2.2,2.9,0.2,3.3C199.4,199.8,199.1,196.5,196.7,196.2z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M204.6,208.5l6.9,3.7c2.1,1.1,4.3,0.2,4.1-1.8l-0.7-10.1L204.6,208.5z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.8,244.5c-3.7,0.3-7.5,0.5-11.3,0.5c-14.9,0-29.2-2.7-42.3-7.7c-0.4-5.9,3.7-9,11-8l31.1,4.4 C165.1,234.5,170.2,239.2,170.8,244.5z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M135.2,238.3c-2.4-0.3-2.2,2.9,0.2,3.3C137.8,241.9,137.6,238.6,135.2,238.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M143.9,239.5c-2.4-0.3-2.2,2.9,0.2,3.3C146.5,243.1,146.3,239.9,143.9,239.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M152.6,240.8c-2.4-0.3-2.2,2.9,0.2,3.3C155.3,244.4,155,241.1,152.6,240.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M177.5,209.2l-24.8-3.5c-6.3-0.9-11.1,2.8-10.7,8.4c0.4,5.6,5.8,10.8,12.1,11.7l24.8,3.5 c7.3,1,11.8-2.4,11.4-8.4C189.8,214.8,185,210.3,177.5,209.2z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M141.9,214.2l0.7,10.5c0.1,2,2.6,3.7,4.6,3.1l6.8-1.9L141.9,214.2z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M156.9,215.2c-2.5-0.3-2.3,3,0.2,3.4C159.6,218.9,159.4,215.5,156.9,215.2z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166,216.4c-2.5-0.3-2.2,3,0.2,3.4C168.7,220.2,168.5,216.8,166,216.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175,217.7c-2.5-0.3-2.2,3,0.2,3.4C177.7,221.5,177.5,218.1,175,217.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M195.9,113.6l8.9,0.7l-0.3,1.8l-8.8-0.6L195.9,113.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M194.6,122.6l8.9,0.7l-0.3,1.8l-8.9-0.6L194.6,122.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M193.2,131.5l8.9,0.6l-0.3,1.8l-9-0.6L193.2,131.5z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M177.1,176.6l9.7,0.6l-1,1.8l-9.8-0.6L177.1,176.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M185.3,158.6l9.6,0.7l-0.7,1.8l-9.5-0.6L185.3,158.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M181.6,167.7l9.6,0.7l-0.8,1.8l-9.6-0.6L181.6,167.7z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M234.1,161.8l9.4,0.6l-0.5,1.8l-9.5-0.6L234.1,161.8z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M231.1,170.8l9.6,0.6l-0.6,1.8l-9.6-0.6L231.1,170.8z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M200.1,159.6l9.4,0.6l-0.7,1.8l-9.5-0.6L200.1,159.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M196.5,168.6l9.6,0.6l-0.8,1.8l-9.6-0.6L196.5,168.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M239.6,134.7l9,0.6l-0.2,1.9l-9-0.6L239.6,134.7z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.4,179.7l9.7,0.6l-0.8,1.8l-9.8-0.6L227.4,179.7z",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M236.6,152.8l9.3,0.6l-0.4,1.9l-9.3-0.6L236.6,152.8z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M238.4,143.8l9.1,0.6l-0.3,1.8l-9.2-0.6L238.4,143.8z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M207.1,132.5l9,0.7l-0.3,1.8l-9-0.6L207.1,132.5z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M192.2,177.5l9.7,0.7l-0.9,1.8l-9.7-0.6L192.2,177.5z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M240.5,125.8l8.9,0.7l-0.2,1.8l-8.9-0.6L240.5,125.8z",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M208.4,123.6l8.9,0.7l-0.3,1.8l-8.9-0.6L208.4,123.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M241.5,116.8l8.9,0.7l-0.3,1.8l-8.8-0.6L241.5,116.8z",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M209.6,114.6l8.9,0.7l-0.2,1.8l-8.9-0.6L209.6,114.6z",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9376 -0.3476 0.3476 0.9376 -2.8447 81.0878)",
    className: "st22",
    cx: 224.6,
    cy: 48.5,
    rx: 8,
    ry: 5.4,
    style: {
      fill: "rgb(0, 139, 133)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9376 -0.3476 0.3476 0.9376 -2.0527 81.3424)",
    className: "st11",
    cx: 225.7,
    cy: 46.4,
    rx: 2.5,
    ry: 1.7,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M225.4,49.1c-0.4,0.1-0.8,0.1-1.1,0c-0.3,0-0.6-0.1-0.9-0.2c-1.4,0.1-2.7,0.4-3.9,1.1 c0.2,1.2,1.4,2.2,3.1,2.4c1.8,0.2,3.9-0.4,5.3-1.5C227.4,50,226.5,49.4,225.4,49.1z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "270.4,57.4 236.6,53.5 235.4,55.7 269.2,59.6 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "272.8,52.8 239,48.9 237.8,51.1 271.6,55 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "252.9,45.7 241.4,44.4 240.3,46.6 251.7,47.8 \t\t\t",
    style: {
      fill: "rgb(0, 139, 133)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.93 -0.3675 0.3675 0.93 -10.9382 82.6625)",
    className: "st13",
    cx: 211.6,
    cy: 70.1,
    rx: 8,
    ry: 5.4,
    style: {
      fill: "rgb(237, 85, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.93 -0.3675 0.3675 0.93 -10.0911 82.9053)",
    className: "st11",
    cx: 212.7,
    cy: 68,
    rx: 2.5,
    ry: 1.7,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M212.4,70.6c-0.4,0.1-0.8,0.1-1.1,0.1c-0.3,0-0.6-0.1-0.9-0.2c-1.4,0.1-2.7,0.5-3.9,1.2 c0.3,1.2,1.4,2.2,3.2,2.3c1.8,0.2,3.9-0.5,5.3-1.7C214.4,71.5,213.6,70.9,212.4,70.6z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "257.6,78 223.7,74.9 222.6,77.1 256.5,80.2 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "259.9,73.3 226,70.2 224.9,72.4 258.8,75.5 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "239.8,66.6 228.4,65.6 227.3,67.8 238.7,68.9 \t\t\t",
    style: {
      fill: "rgb(237, 85, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9225 -0.3859 0.3859 0.9225 -19.6163 86.5668)",
    className: "st21",
    cx: 205.8,
    cy: 92.1,
    rx: 8,
    ry: 5.4,
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9225 -0.3859 0.3859 0.9225 -18.7177 86.7956)",
    className: "st11",
    cx: 206.8,
    cy: 90,
    rx: 2.5,
    ry: 1.7,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.6,92.7c-0.4,0.1-0.8,0.1-1.1,0.1c-0.3,0-0.6-0.1-0.9-0.2c-1.4,0.1-2.7,0.6-3.9,1.2 c0.3,1.2,1.5,2.1,3.2,2.3c1.8,0.1,3.8-0.6,5.2-1.8C208.7,93.5,207.8,93,206.6,92.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "251.9,99.1 218,96.7 216.9,98.9 250.9,101.4 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "254.2,94.4 220.3,92 219.2,94.3 253.1,96.7 \t\t\t",
    style: {
      fill: "rgb(239, 214, 199)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "234,88.2 222.5,87.3 221.4,89.6 232.9,90.4 \t\t\t",
    style: {
      fill: "rgb(255, 193, 87)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.89aea97fe7a9646a79f10e6b2d37f9f5.svg";
export { ForwardRef as ReactComponent };